import React from "react";

const SearchIcon = ({ className, height, width }) => {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <title>search</title>
      <path d="M30.027 29.813l-7.111-5.013c-0.782-0.569-0.96-1.6-0.427-2.382v0c0.533-0.747 1.6-0.96 2.382-0.391l7.111 5.013c0.747 0.533 0.96 1.6 0.391 2.347v0c-0.533 0.782-1.6 0.96-2.347 0.427z"></path>
      <path d="M13.067 3.538c-7.218 0-13.084 5.867-13.084 13.084s5.867 13.084 13.084 13.084 13.084-5.867 13.084-13.084-5.867-13.084-13.084-13.084zM13.067 26.862c-5.653 0-10.24-4.587-10.24-10.24s4.587-10.204 10.24-10.204 10.24 4.551 10.24 10.204-4.587 10.24-10.24 10.24z"></path>
      <path d="M13.067 7.733v1.956c3.84 0 6.969 3.129 6.969 6.933h1.92c0-4.907-3.982-8.889-8.889-8.889z"></path>
    </svg>
  );
};

export default SearchIcon;
